import React from 'react';
export const ComparisonSection = () => {
  const rows = ['Sistema de práctica diaria de 15 minutos con el sistema espejo. El padre acompaña leyendo la guía en español desde el día 1.', '200 flashcards de vocabulario para repasar en el auto, en la mesa o antes de dormir. Sin necesitar conexión a internet.', 'Mock test completo idéntico al examen Cambridge real, con grilla de corrección para que el padre pueda evaluar.', 'Plan de 30 días pre-examen para llegar organizado, sin pánico de último momento, con todo practicado y repasado.', 'Pronunciación en rojo en cada tabla. El padre puede decirle cómo suena cada palabra sin saber inglés.', '50 Speaking Cards para practicar el oral en casa con rol play bilingüe. El examinador nota la diferencia.', 'Grammar Sin Vueltas con código de colores. Cada tema gramatical con su explicación en español y sus ejercicios resueltos.', 'Una familia que estudia junta. Un padre que puede ayudar. Un hijo que llega seguro al examen.'];
  return <section className="bg-familia-card py-10 md:py-16 px-4 md:px-6" data-id="element-37">
      <div className="max-w-5xl mx-auto w-[92%] md:w-full" data-id="element-38">
        <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold text-center mb-8 md:mb-16 leading-tight" data-id="element-39">
          ¿Cuánto cuesta NO tener <br className="hidden md:block" data-id="element-40" />
          el English en Familia?
        </h2>

        <div className="space-y-3 md:space-y-4" data-id="element-41">
          {rows.map((row, i) => <div key={i} className="bg-familia-section border border-familia-green/25 p-4 md:p-6 rounded-2xl flex items-start gap-3 md:gap-4" data-id="element-42">
              <span className="text-familia-green text-xl shrink-0" data-id="element-43">✅</span>
              <p className="text-white/90 text-[15px] md:text-base leading-relaxed" data-id="element-44">
                <span className="text-familia-cyan font-bold block mb-1" data-id="element-45">
                  Con English en Familia:
                </span>
                {row}
              </p>
            </div>)}
        </div>

        <div className="mt-12 md:mt-24 text-center" data-id="element-46">
          <h3 className="text-[22px] sm:text-2xl md:text-4xl font-display font-bold mb-4 leading-tight" data-id="element-47">
            El próximo lunes tu hijo/a puede seguir preparando Cambridge solo.{' '}
            <br className="hidden md:block" data-id="element-48" />O puede tener a toda su familia
            acompañándolo desde hoy.
          </h3>
          <p className="text-familia-gray text-[15px] md:text-xl" data-id="element-49">
            ¿Cuánto cuesta NO tenerlo?
          </p>
        </div>
      </div>
    </section>;
};